import React, { Fragment, useEffect, useState } from 'react'
import { JobStatus } from './JobStatus'
import { JobTechnichian } from './JobTechnichian'
import { JobGroup } from './JobGroup'
import {
  Row,
  Col,
  Divider,
  Card,
  Modal,
  Button,
  Popconfirm,
  message,
  Badge,
  Image,
} from 'antd'
import { JobShowPostpone } from './JobShowPostpone'
import JobView from './job-view/index'
import Gallery from '../gallery/gallery-list'
import { CheckCircleFilled, CheckCircleOutlined, CheckCircleTwoTone, ExclamationCircleFilled, HomeOutlined, PlusCircleFilled, SendOutlined, SettingFilled, UserOutlined } from '@ant-design/icons'
import InformStore from '../../stores/InformStore'
import { JobDateTimeCalendar } from './JobDateTimeCalendar'
import { Config } from '../../config'
import { JobService } from '../../services'
import { Moment } from '../../helpers'
import { Observer } from 'mobx-react'
import { JobSignature } from './job-signature/index'
import { FullScreen, useFullScreenHandle } from 'react-full-screen'

export const JobCalendarItem = (props) => {
  const colDate = { xs: 24, sm: 10, md: 8, lg: 6, xl: 6 }
  const colDetail = { xs: 24, sm: 14, md: 16, lg: 18, xl: 18 }

  const [beforeImages, setBeforeImages] = useState([])
  const [afterImages, setAfterImages] = useState([])
  const [selected, setSelected] = useState(null)
  const [visibleModalView, setVisibleModalView] = useState(false)
  const [visibleModalSig, setVisibleModalSig] = useState(false)
  const job = props.job

  useEffect(() => {
    let gallery1 = []
    job.beforeImages.map((photo) => {
      gallery1.push({
        original: photo.url,
        thumbnail: photo.thumbnail,
        description: photo.description,
        size: photo.size,
        extension: photo.extension,
        url: photo.url,
        height: 1,
        width: 1,
        image: photo.url,
      })
    })
    setBeforeImages(gallery1)
  }, [job])

  useEffect(() => {
    let gallery2 = []
    job.afterImages.map((photo) => {
      gallery2.push({
        original: photo.url,
        thumbnail: photo.thumbnail,
        description: photo.description,
        size: photo.size,
        extension: photo.extension,
        url: photo.url,
        height: 1,
        width: 1,
        image: photo.url,
      })
    })
    setAfterImages(gallery2)
  }, [job])

  const loadJob = (id) => {
    JobService.view(id)
      .then((rs) => {
        if (rs) {
          InformStore.setJob(rs.data.data)
          console.log('loadjob', rs.data.data)
        }
      })
      .catch((err) => {
        console.log('err', err)
        message.error(err.response.message)
      })
  }
  const onclickView = (item) => {
    console.log('view', item.id)
    JobService.view(item.id)
      .then((rs) => {
        if (rs) {
          InformStore.setJob(rs.data.data)
          console.log('loadjob', InformStore.getJob)
          setSelected.value = item
          setVisibleModalView(true)
        }
      })
      .catch((err) => {
        console.log('err', err)
        message.error(err.response.message)
      })
  }

  const confirmStartWork = () => {
    JobService.start(job.id)
      .then((rs) => {
        if (rs) {
          InformStore.setJob(rs.data.data)
          message.success(rs.data.message)
          props.onStartJob({
            data: rs.data.data,
            message: rs.data.message,
            success: rs.data.success,
          })
        }
      })
      .catch((err) => {
        console.log('err', err)
        message.error(err.response.message)
      })
  }

  
  const confirmSendJob = () => {
    JobService.sendJob(job.id)
      .then((rs) => {
        if (rs) {
          InformStore.setJob(rs.data.data)
          message.success(rs.data.message)
          props.onSendJob({
            data: rs.data.data,
            message: rs.data.message,
            success: rs.data.success,
          })
        }
      })
      .catch((err) => {
        console.log('err', err)
        message.error(err.response.message)
      })
  }

  const handle = useFullScreenHandle()

  const cardStyle = {
    width: '360px',
    height: '192px',
    borderRadius: '16px',
    marginRight: '24px',
    boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)',
    backgroundColor: '#f4f4f4',
  }

  return (
    <Observer>
      {() => {
        return (
          <React.Fragment>
            {visibleModalView ? (
              <>
                <Modal
                  style={{ top: 1 }}
                  title={job.project ? job.project.name : job.id}
                  open={visibleModalView}
                  onCancel={() => setVisibleModalView(false)}
                  cancelText="ปิด"
                  destroyOnClose={true}
                  maskClosable={false}
                  okText={'ตกลง'}
                  okButtonProps={{
                    style: { display: 'none' },
                  }}
                  cancelButtonProps={{
                    type: 'primary',
                  }}
                  width={960}
                >
                  <JobView
                    job={InformStore.getJob}
                    reload={() => loadJob(InformStore.getJob.id)}
                  />
                </Modal>
              </>
            ) : null}
            <div
              style={{
                borderRadius: '0px',
                boxShadow: '5px 8px 24px 5px rgba(208, 216, 243, 0.6)',
                backgroundColor: '#f4f4f4',
                marginBottom: 15,
                border: 'solid 1px #a6a6a6',
              }}
            >
              <Card className={cardStyle}>
                <Row>
                  <Col {...colDate}>
                    <Row style={{ marginBottom: 15 }} gutter={[8, 8]}>
                      <Col>
                        <a onClick={() => onclickView(job)}>
                          <JobDateTimeCalendar
                            start={job.start_time}
                            end={job.end_time}
                            jobStatus={job.job_status}
                          />
                        </a>
                 
                        {/* แสดงลำดับ */}
                        {/* {props.seq ? (
                          <span
                            style={{
                              padding: 3,
                              margin: 3,
                            }}
                          >
                            ลำดับ {props.seq}
                          </span>
                        ) : (
                          ''
                        )} */}
                        <div
                          style={{
                            margin: 3,
                            fontSize: 12
                          }}
                        >
                          <JobStatus
                            name={job.jobStatusName}
                            statusId={job.job_status}
                          />
                        </div>

                        {/* เลขทีงาน */}
                        <span
                          style={{
                            color: '#ffffff',
                            padding: 3,
                            margin: 3,
                            backgroundColor: '#222222',
                          }}
                        >
                          #J{job.id}
                        </span>

                        <div style={{ marginTop: 7 }}>
                          {/* แสดงปุ่มเริ่มทำงาน */}
                          {job.job_status == Config.job.status.OPEN.value &&
                          job.start_job_at < 1 &&
                          job.send_job_at < 1 ? (
                            <>
                              <Popconfirm
                                placement="topRight"
                                title={'ยืนยันเริ่มทำงาน #' + job.id + ' ?'}
                                onConfirm={() => confirmStartWork()}
                                okText="ใช่"
                                cancelText="ไม่ใช่"
                              >
                                <Button
                                  type="ghost"
                                  size="small"
                                  style={{
                                    color: 'blue',
                                    fontSize: 12
                                  }}
                                  icon={<CheckCircleFilled/>}
                                >
                                  กดรับงาน/เริ่มทำงาน
                                </Button>
                              </Popconfirm>
                            </>
                          ) : null}
                          {/* แสดงปุ่มส่งงาน */}
                          {job.send_job_at < 1 || !job.send_job_at ? (
                            <>
                              <Button
                                type="ghost"
                                size="small"
                                style={{
                                  fontSize: 12,
                                  color: 'green'
                                }}
                                icon={<CheckCircleFilled/>}
                                onClick={() => setVisibleModalSig(true)}
                                
                              >
                                กดส่งงาน
                              </Button>
                            </>
                          ) : null}
                        </div>
                      </Col>
                    </Row>

                    {/* {job.imageCover ? (
                <div
                  align="center"
                  style={{
                    marginTop: '5px',
                    width: '126px',
                    backgroundColor: '#222222',
                    padding: 3,
                  }}
                >
                  <img
                    src={job.imageCover.thumbnail}
                    style={{
                      width: 120,
                      height: 'auto',
                      backgroundColor: '#222222',
                    }}
                  />
                </div>
              ) : null} */}
                  </Col>
                  <Col {...colDetail}>
                    <span   style={{ fontSize: '1em' }}>
                      <a onClick={() => onclickView(job)}>
                        <strong style={{ color: '#1b6ac2' }}>{job.list}</strong>
                      </a>
                    </span>
                    {job.postpone_mark ? <JobShowPostpone item={job} /> : ''}
                    <span style={{ marginLeft: 10 }}>
                      
                      <span
                        style={{
                          display: 'inline-block',
                        }}
                      >
                        {job.description}
                      </span>
                    </span>
                   
                    <div>
                    <JobGroup group={job.group} groupId={job.group_id} />
                      <section
                        onClick={() => onclickView(job)}
                        style={{ cursor: 'pointer' }}
                      >
                        <Row gutter={[8, 8]}>
                          {beforeImages && beforeImages.length > 0 ? (
                            <Col>
                              ภาพก่อนซ่อม
                              <Gallery data={beforeImages} />
                            </Col>
                          ) : null}

                          {afterImages && afterImages.length > 0 ? (
                            <Col>
                              ภาพหลังซ่อม
                              <Gallery data={afterImages} />
                            </Col>
                          ) : null}
                        </Row>
                      </section>
                    </div>
                    <div  style={{ fontSize: '11px' }}>
                    <Row gutter={[8]}>
                      <Col>
                        {job.project ? (
                          <div>
                            <HomeOutlined /> {job.project.name}
                          </div>
                        ) : (
                          ''
                        )}
                      </Col>
                      <Col>
                        {job.home ? (
                          <div>
                            {job.home.home_no !== undefined
                              ? ' เลขที่ ' + job.home.home_no
                              : null}
                            {job.home.homeType &&
                            job.home.homeType.name !== undefined
                              ? ' (' + job.home.homeType.name + ')'
                              : null}
                            {job.home.plan_no !== undefined
                              ? ' แปลง ' + job.home.plan_no
                              : null}
                          </div>
                        ) : (
                          ''
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div style={{ fontSize: '11px' }}>
                          <UserOutlined />{' '}
                          {job.responsible_id
                            ? job.responsible_name
                            : 'ไม่ได้ระบุ'}{' '}
                          (ผู้รับผิดชอบ)
                          {job.technicians && job.technicians.length > 0 ? (
                            <>
                              <div
                                // style={{
                                //   border: 'solid 1px #cccccc',
                                //   backgroundColor: '#f3f3f3',
                                //   padding: 3,
                                // }}
                              >
                                <JobTechnichian technicians={job.technicians} />
                              </div>
                            </>
                          ) : null}
                          {job.technician_name_other ? (
                            <>
                              <div
                                // style={{
                                //   border: 'solid 1px #cccccc',
                                //   backgroundColor: '#f3f3f3',
                                //   padding: 3,
                                // }}
                              >
                                <UserOutlined /> {job.technician_name_other}{' '}
                                (ช่างอื่น ๆ)
                              </div>
                            </>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    {job.start_job_at ? (
                      <Row>
                        <Col>
                          <div
                            style={{
                              color: '#e87a00',
                              // backgroundColor: '#faeea9',
                              // border: 'solid 1px #a6a6a6',
             
    
                            }}
                          >
                            <CheckCircleFilled /> {job.start_job_user}{' '}
                            : กดเริ่มทำงานแล้วเมื่อ{' '}
                            {Moment.unix(job.start_job_at).format('lll')}{' '}
                          </div>
                        </Col>
                      </Row>
                    ) : null}

                    {job.send_job_at > 0 ? (
                      <Row>
                        <Col>
                          <div
                            style={{
                              color: '#2d9b67',
                              // backgroundColor: '#faeea9',
                              // border: 'solid 1px #a6a6a6',
                   
                            }}
                          >
                            <CheckCircleFilled /> {job.send_job_user} : กดส่งงานเมื่อ{' '}
                            {Moment.unix(job.send_job_at).format('lll')}{' '}
                          </div>
                        </Col>
                      </Row>
                    ) : null}
                    </div>


                  </Col>
                </Row>
              </Card>
            </div>

            {/* ///////////////////// ส่งงานและลานเซ็นต์ ////////////////////////// */}
            {visibleModalSig && job.send_job_at < 1 ? (
              <JobSignature
                key={'sigcomponent' + job.id}
                job={job}
                visible={visibleModalSig}
                onClose={() => setVisibleModalSig(false)}
                canSendJob={true}
                onSave={(data) => {
                  props.onSendJob(data)
                }}
                onSendJob={(data) => {
                  setVisibleModalSig(false)
                  props.onSendJob(data)
                }}
                onHide={(data) => {
                  setVisibleModalSig(false)
                }}
              />
            ) : (
              ''
            )}
          </React.Fragment>
        )
      }}
    </Observer>
  )
}
